import React from 'react';
import PropTypes from 'prop-types';
import {Stack, Switch, Tooltip, Typography} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

// AD-2689 (Maria, 14 October 2026): the form restrictions are Yes/No questions, worded the same in the Create Form box
// and in Form Settings. Each defaults to No.
const RestrictionQuestions = ({items, disabled = false}) => (
    <Stack spacing={0.75} data-testid="restriction-questions">
        {items.map(item => (
            <Stack
                key={item.key}
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                spacing={3}
                data-testid={`restriction-${item.key}`}
                sx={{px: 1.5, py: 0.5, borderRadius: 2, border: '1px solid #e3e8ef'}}
            >
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Typography>{item.question}</Typography>
                    {item.help && (
                        <Tooltip title={item.help} placement="right" arrow>
                            <InfoOutlinedIcon fontSize="small" sx={{color: 'text.secondary', cursor: 'help'}}/>
                        </Tooltip>
                    )}
                </Stack>
                <Stack direction="row" alignItems="center" spacing={0.5} sx={{flexShrink: 0}}>
                    <Typography variant="body2" color={item.checked ? 'text.secondary' : 'text.primary'}>No</Typography>
                    <Switch
                        checked={!!item.checked}
                        disabled={disabled || !!item.disabled}
                        onChange={(event) => item.onChange(event.target.checked)}
                        inputProps={{'aria-label': item.question}}
                    />
                    <Typography variant="body2" color={item.checked ? 'text.primary' : 'text.secondary'}>Yes</Typography>
                </Stack>
            </Stack>
        ))}
    </Stack>
);

RestrictionQuestions.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
        question: PropTypes.string.isRequired,
        checked: PropTypes.bool,
        onChange: PropTypes.func.isRequired,
        disabled: PropTypes.bool,
        help: PropTypes.string,
    })).isRequired,
    disabled: PropTypes.bool,
};

export default RestrictionQuestions;
